import { render, staticRenderFns } from "./EditarTipoTurno.vue?vue&type=template&id=30098567&scoped=true"
import script from "./EditarTipoTurno.vue?vue&type=script&lang=js"
export * from "./EditarTipoTurno.vue?vue&type=script&lang=js"
import style0 from "./EditarTipoTurno.vue?vue&type=style&index=0&id=30098567&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30098567",
  null
  
)

export default component.exports